<template>
  <div>
    <div class="decision-aid" :class="{ mobile: device === 'mobile' }">
      <div class="backdrop" @click="$emit('close')"></div>
      <div class="decision-body">
        <div class="header" v-if="type === 'pressure'">
          <span class="title">{{ $t('cylinder.helpTool.pressureTitle') }} <span>({{ forceType }})</span></span>
          <span class="close" @click="$emit('close')">&times;</span>
        </div>
        <div class="header" v-if="type === 'workPressure'">
          <span class="title">{{ $t('cylinder.helpTool.workPressureTitle') }} <span>({{ forceType }})</span></span>
                    <form class="radio-container" v-if="circuit === 'double'">
                      <input type="radio" :value="1" v-model="power" name="power" id="push"
                             checked="checked">
                      <label for="push">{{ $t('cylinder.helpTool.pushForce') }}</label>

                      <input type="radio" :value="2" v-model="power" name="power" id="pull">
                      <label for="pull">{{ $t('cylinder.helpTool.pullForce') }}</label>
                    </form>
          <span class="close" @click="$emit('close')">&times;</span>
        </div>
        <div class="header" v-if="type === 'speed'">
          <span class="title" v-if="power === 1">{{ $t('cylinder.helpTool.speedTitleOut') }}</span>
          <span class="title" v-if="power === 2">{{ $t('cylinder.helpTool.speedTitleIn') }}</span>
          <form class="radio-container" v-if="circuit === 'double'">
            <input type="radio" :value="1" v-model="power" name="power" id="push"
                   checked="checked"><label for="push">{{ $t('cylinder.helpTool.out') }}</label>
            <input type="radio" :value="2" v-model="power" name="power" id="pull"><label
              for="pull">{{ $t('cylinder.helpTool.in') }}</label>
          </form>
          <span class="close" @click="$emit('close')">&times;</span>
        </div>

        <table>
          <colgroup v-if="type === 'speed' || type === 'workPressure'">
            <col span="1" style="width: 10%;">
            <col span="1" style="width: 10%;">
            <col span="1" style="width: 10%;">
            <col span="1" style="width: 10%;">
            <col span="1" style="width: 10%;">
            <col span="1" style="width: 10%;">
            <col span="1" style="width: 10%;">
            <col span="1" style="width: 10%;">
            <col span="1" style="width: 10%;">
          </colgroup>
          <colgroup v-else-if="type === 'pressure'">
            <col span="1" style="width: 10%;">
            <col span="1" style="width: 10%;">
            <col span="1" style="width: 40%;">
            <col span="1" style="width: 40%;">
            <col span="1" style="width: 40%;">
            <col span="1" style="width: 40%;">
          </colgroup>
          <thead>
          <tr>
            <th v-if="subtype === 'piston'">{{ $t('cylinder.helpTool.piston') }}</th>
            <th v-else>{{ $t('cylinder.helpTool.piston') }}</th>
            <th v-if="subtype === 'rod'">{{ $t('cylinder.helpTool.rod') }}</th>
            <th v-else>{{ $t('cylinder.helpTool.rod') }}</th>
                        <th v-if="type === 'workPressure'" v-for="(val) in aidHeaderPressure" v-text="val + ' bar'"></th>
            <th v-if="type === 'speed'" v-for="(val) in aidHeaderSpeed" v-text="val + ' l/min'"></th>
            <th v-if="type === 'pressure' && power === 1">{{ $t('cylinder.helpTool.pushForce') }} <span v-if="forceUnit === 2">(kN)</span><span
                v-else>(kg)</span> {{ $t('cylinder.helpTool.atBar', {bar: bar}) }}
            </th>
            <th v-if="type === 'pressure' && power === 2">{{ $t('cylinder.helpTool.pullForce') }} <span v-if="forceUnit === 2">(kN)</span><span
                v-else>(kg)</span> {{ $t('cylinder.helpTool.atBar', {bar: bar}) }}
            </th>
            <th v-if="type === 'pressure' && power === 1">{{ $t('cylinder.helpTool.outSpeedAt', {lpm: lpm}) }}</th>
            <th v-if="type === 'pressure' && power === 2">{{ $t('cylinder.helpTool.inSpeedAt', {lpm: lpm}) }}</th>
          </tr>
          </thead>
          <tbody v-if="type === 'pressure'">
          <tr v-for="(row, rowIndex) in aidRows" @click="setCalcValue(row.pistonDiameter, row.rodDiameter, bar)">
            <td v-for="(value, key) in row" v-text="value" class="cursor"></td>
            <td v-if="power === 1">{{ round(getForce(getBoreArea(row.pistonDiameter), bar, forceType)) }}</td>
            <td v-if="power === 2">{{
                round(getForce(getRodArea(row.pistonDiameter, row.rodDiameter), bar, forceType))
              }}
            </td>

            <td v-if="power === 1">{{ round(getAreaSpeed(getBoreArea(row.pistonDiameter), lpm)) }}</td>
            <td v-if="power === 2">{{ round(getAreaSpeed(getRodArea(row.pistonDiameter, row.rodDiameter), lpm)) }}</td>

          </tr>
          </tbody>
          <tbody v-if="type === 'speed'">
          <tr v-for="(row, rowIndex) in aidRows">
            <td v-for="(value, key) in row" v-text="value" class="cursor"></td>
            <td v-if="power === 1"
                v-for="aidBar in aidHeaderSpeed" @click="setCalcValue(row.pistonDiameter, row.rodDiameter, aidBar)">
              <span>{{
                  (100 / ((((boreSurface[rowIndex] * 100 / 10) / 1000) / aidBar) * 60)).toFixed(2)
                }}</span>
            </td>
            <td v-if="power === 2"
                v-for="aidBar in aidHeaderSpeed" @click="setCalcValue(row.pistonDiameter, row.rodDiameter, aidBar)">
              <span>{{
                  (100 / ((((pistonSurface[rowIndex] * 100 / 10) / 1000) / aidBar) * 60)).toFixed(2)
                }}</span>
            </td>
          </tr>
          </tbody>

          <tbody v-if="type === 'workPressure'">
          <tr v-for="(row, rowIndex) in aidRows" @click="setCalcValue(row.pistonDiameter, row.rodDiameter, bar)">
            <td v-for="(value, key) in row" v-text="value" class="cursor"></td>
            <td v-if="power === 1"
                v-for="aidBar in aidHeaderPressure" @click="setCalcValue(row.pistonDiameter, row.rodDiameter, aidBar)">
              <span v-if="forceUnit === 1">{{ round(getForce(aidBar, boreSurface[rowIndex], forceType)) }}</span>
<!--              <span v-if="forceUnit === 1">{{ (Math.round(aidBar * boreSurface[rowIndex] * 100) / 100) }}</span>-->
              <span v-if="forceUnit === 2">{{ round(getForce(aidBar, boreSurface[rowIndex], forceType)) }}</span>
<!--              <span v-if="forceUnit === 2">{{ Math.round((aidBar * boreSurface[rowIndex] * 100) / newton) / 100 }}</span>-->
            </td>
            <td v-if="power === 2"
                v-for="aidBar in aidHeaderPressure" @click="setCalcValue(row.pistonDiameter, row.rodDiameter, aidBar)">
              <span v-if="forceUnit === 1">{{ round(getForce(aidBar, pistonSurface[rowIndex], forceType)) }}</span>
<!--              <span v-if="forceUnit === 1">{{ Math.round(aidBar * pistonSurface[rowIndex] * 100) / 100 }}</span>-->
              <span v-if="forceUnit === 2">{{ round(getForce(aidBar, pistonSurface[rowIndex], forceType)) }}</span>
<!--              <span v-if="forceUnit === 2">{{ Math.round((aidBar * pistonSurface[rowIndex] * 100) / newton) / 100 }}</span>-->
            </td>
          </tr>
          </tbody>
        </table>
      </div>
    </div>
  </div>
</template>

<script>
import {mapGetters} from 'vuex';

import {getBoreArea, getRodArea, getAreaSpeed, getForce, round} from '@/helpers/calculations';

export default {
  name: "DecisionAid",

  props: {
    type: {
      type: String,
      default: '',
    },
    subtype: {
      type: String,
      default: '',
    },
    tab: {
      type: Number,
      default: 0,
    }
  },

  data() {
    return {
      power: 1,
      newton: 101.9716213,
      aidHeaderPressure: [25, 50, 75, 100, 150, 200, 250],
      aidHeaderSpeed: [1, 3, 5, 10, 20, 50, 100],
      aidRowsRod: [
        {
          rodDiameter: 16,
        },
        {
          rodDiameter: 20,
        },
        {
          rodDiameter: 25,
        },
        {
          rodDiameter: 30,
        },
        {
          rodDiameter: 30,
        },
        {
          rodDiameter: 35,
        },
        {
          rodDiameter: 40,
        },
        {
          rodDiameter: 40,
        },
        {
          rodDiameter: 50,
        },
        {
          rodDiameter: 50,
        },
        {
          rodDiameter: 50,
        },
        {
          rodDiameter: 70,
        },
      ],
      aidRowsPiston: [
        {
          pistonDiameter: 25,
        },
        {
          pistonDiameter: 32,
        },
        {
          pistonDiameter: 40,
        },
        {
          pistonDiameter: 50,
        },
        {
          pistonDiameter: 60,
        },
        {
          pistonDiameter: 60,
        },
        {
          pistonDiameter: 70,
        },
        {
          pistonDiameter: 80,
        },
        {
          pistonDiameter: 80,
        },
        {
          pistonDiameter: 90,
        },
        {
          pistonDiameter: 100,
        },
        {
          pistonDiameter: 120,
        },
      ],
      aidRows: [
        {
          pistonDiameter: 25,
          rodDiameter: 16,
        },
        {
          pistonDiameter: 32,
          rodDiameter: 20,
        },
        {
          pistonDiameter: 40,
          rodDiameter: 25,
        },
        {
          pistonDiameter: 50,
          rodDiameter: 30,
        },
        {
          pistonDiameter: 60,
          rodDiameter: 30,
        },
        {
          pistonDiameter: 60,
          rodDiameter: 35,
        },
        {
          pistonDiameter: 70,
          rodDiameter: 40,
        },
        {
          pistonDiameter: 80,
          rodDiameter: 40,
        },
        {
          pistonDiameter: 80,
          rodDiameter: 50,
        },
        {
          pistonDiameter: 90,
          rodDiameter: 50,
        },
        {
          pistonDiameter: 100,
          rodDiameter: 50,
        },
        {
          pistonDiameter: 120,
          rodDiameter: 70,
        },
      ]
    }
  },

  methods: {
    setCalcValue(piston, rod, bar) {
      this.$store.dispatch('preference/setCilinderPistonDiameter', piston);
      this.$store.dispatch('preference/setCilinderRodDiameter', rod);

      if (this.type === 'pressure' || this.type === 'workPressure') {
        this.$store.commit('preference/setCilinderPressure', bar);
      } else {
        this.$store.commit('preference/setCilinderOilFlow', bar);
      }
      if(this.$store.state.preference.selectedCilinder !== null) {
        this.$store.commit('preference/resetCilinderSelection');
      }
    },
    getBoreArea, getRodArea, getAreaSpeed, getForce, round,
  },

  computed: {
    ...mapGetters({
      cilinderOptions: 'preference/getCilinderOptions',
      device: 'getDevice',
    }),

    forceType() {
      if (this.cilinderOptions.forceUnit === 1) {
        return 'kg';
      } else if (this.cilinderOptions.forceUnit === 2) {
        return 'kN';
      }
    },
    circuit() {
      if (this.cilinderOptions.circuit === 1) {
        return 'double';
      } else if (this.cilinderOptions.circuit === 2) {
        return 'single';
      }
    },
    bar() {
      return this.cilinderOptions.pressure;
    },

    lpm() {
      return this.cilinderOptions.oilFlow;
    },

    boreSurface() {
      let array = []
      for (let i = 0; i < this.aidRows.length; i++) {
        array.push(Math.pow((this.aidRows[i].pistonDiameter / 2), 2) * Math.PI / 100);
      }
      return array;
    },
    pistonSurface() {
      let array = []
      for (let i = 0; i < this.aidRows.length; i++) {
        array.push(this.boreSurface[i] - (Math.pow((this.aidRows[i].rodDiameter / 2), 2)) * Math.PI / 100);
      }
      return array;
    },
    forceUnit() {
      return this.cilinderOptions.forceUnit;
    }
    // pressureForce() {
    //   let array = []
    //   for (let i = 0; i < this.aidRows.length; i++) {
    //     array.push((this.pressure * this.boreSurface[i]));
    //   }
    //   return array;
    // },
    // tractionForce() {
    //   let array = []
    //   for (let i = 0; i < this.aidRows.length; i++) {
    //     array.push((this.pressure * this.pistonSurface[i]));
    //   }
    //   return array;
    // },
    // outgoingMm() {
    //   let array = []
    //   for (let i = 0; i < this.aidRows.length; i++) {
    //     array.push(100 / ((((this.boreSurface[i] * 100 / 10) / 1000) / this.oilFlow) * 60));
    //   }
    //   return array;
    // },
    // incomingMm() {
    //   let array = []
    //   for (let i = 0; i < this.aidRows.length; i++) {
    //     array.push(100 / ((((this.pistonSurface[i] * 100 / 10) / 1000) / this.oilFlow) * 60));
    //   }
    //   return array;
    // },
    // pressure() {
    //   return this.cilinderOptions.pressure;
    // },
    // oilFlow() {
    //   return this.cilinderOptions.oilFlow;
    // },
  },

  created() {
    this.power = this.tab;
  }
}
</script>

<style scoped lang="scss">

.decision-aid {
  position: relative;

  &.mobile {
    .backdrop {
      z-index: 100;
    }

    .decision-body {
      left: 0;
      width: 100%;
      padding: 0 16px;
      z-index: 101;

      .header {
        flex-direction: column;
        padding: 10px 0 0 0;

        .radio-container {
          margin-left: 0;
          margin-top: 2px;
        }

        .close {
          right: 0;
          top: 10px;
        }
      }

      table {
        overflow: auto;
        width: 100%;
        display: block;
      }
    }
  }

  .backdrop {
    position: fixed;
    z-index: 9;
    top: 0;
    left: 0;
    right: 0;
    bottom: 0;
    background-color: rgba(0, 0, 0, 0.7);
  }

  .decision-body {
    background-color: white;
    z-index: 10;
    position: absolute;
    top: 100px;
    left: 25%;
    display: flex;
    flex-direction: column;
    width: 700px;

    .header {
      padding: 14px 19px 20px;
      height: 88px;
      display: flex;
      flex-direction: row;
      align-items: center;
      align-content: center;
      position: relative;

      .title {
        font-size: 20px;
        font-family: neue-haas-grotesk-display, sans-serif;
        font-weight: 700;
      }

      .close {
        font-size: 30px;
        transition: all ease 0.3s;
        position: absolute;
        right: 31px;
        top: 26px;
        color: #A4AFB7;
        opacity: 1;
        text-shadow: none;
        font-weight: 100;

        &:hover {
          cursor: pointer;
          color: darken(#A4AFB7, 30%);
        }

      }

      .radio-container {
        margin-right: auto;
        margin-left: 20px;
        width: 265px;
        border-radius: 50px;
        border: 2px solid #EBEBEB;
        height: 36px;
        display: flex;
        align-items: center;
        justify-content: space-evenly;
        background-color: white;
        transition: all ease 0.3s;

        label {
          cursor: pointer;
          display: flex;
          justify-content: center;
          font-size: 12px;
          margin: 0;
          border-radius: 25px;
          width: 50%;
          padding: 7px;
          user-select: none;
          font-family: neue-haas-grotesk-display, sans-serif;
        }

        input[type="radio"] {
          display: none;


          &:checked + label {
            background-color: #3DB0C7;
            color: white;
          }
        }
      }
    }

    table {
      margin-top: 10px;
      border-collapse: separate;
      border-spacing: 3px 0;
      background-color: #F0F0F0;

      th, td {
        &:nth-child(2) {
          border-collapse: unset;
          border-spacing: unset;
          border-right: #AFAFAF 4px solid;
        }
      }

      th {
        text-align: center;
        background-color: white;
        font-size: 12px;
        font-family: neue-haas-grotesk-display, sans-serif;
        font-weight: 700;
        cursor: default;
      }

      td {
        font-size: 12px;
        border-spacing: 4px;
        padding: 8px 10px;
        text-align: center;

        &:hover {
          color: white;
          background-color: rgba(61, 176, 199, 0.5);
        }
      }

      tr {
        cursor: pointer;

        &:nth-child(even) {
          background-color: white;

          &:hover {
            background-color: rgba(61, 176, 199, 0.25);

            > td:nth-child(1), td:nth-child(2) {
              color: white;
              background-color: rgba(61, 176, 199, 0.5);
            }
          }
        }

        &:nth-child(odd) {
          background-color: #EBEBEB;

          &:hover {
            background-color: rgba(61, 176, 199, 0.25);

            > td:nth-child(1), td:nth-child(2) {
              color: white;
              background-color: rgba(61, 176, 199, 0.5);
            }
          }
        }

        .selected {
          background-color: #3DB0C7;
        }
      }
    }
  }
}
</style>
